import formatFileSize from './utils'

const messages = {
  _default: () => `érték nem érvényes`,
  after: (field, [target, , inclusion]) => `${inclusion ? 'vagy egyenlőnek ' : ''}${target}. után kell lennie`,
  alpha_dash: () =>
    `a mező túl sok alfanumerikus és speciális karaktert tartalmaz`,
  alpha_num: () => `a mező csak alfanumerikus tartalmazhat`,
  alpha: () => `a mező csak betűket tartalmazhat`,
  alpha_spaces: () => `a mező csak betűket és üres karakterket tartalmazhat`,
  before: (field, [target, inclusion]) => `előtte kell ${inclusion ? 'vagy egyenlő ' : ''}${target}.`,
  between: (field, [min, max]) => `mezőérték ${min} és ${max} között.`,
  confirmed: () => `a megerősítés nem egyezik`,
  credit_card: () => `nem érvényes mező`,
  date_between: (field, [min, max]) => `${min} és ${max} között kell lennie.`,
  date_format: (field, [format]) => `a helyes formátum ${format}`,
  decimal: (field, [decimals = '*'] = []) => `a mező numerikus és tartalmaznia kell ${!decimals || decimals === '*' ? '' : decimals} tizedesjegy.`,
  digits: (field, [length]) =>
    `a mező numerikus és pontosan  ${length} számjegyet tartalmaz.`,
  dimensions: (field, [width, height]) =>
    `a mező ${width} pixelszer ${height} pixels legyen.`,
  email: () => `a mezőnek valós e-mail címet kell tartalmaznia.`,
  ext: () => `a mezőnek valós fájl kell tartalmaznia`,
  image: () => `a mező kép formátumú kell legyen`,
  in: () => `a mezőnek valós értéket kell tartalmaznia`,
  integer: () => `a mező integer típusú`,
  ip: () => `a mezőnek valós IP címet kell tartalmaznia`,
  length: (field, [length, max]) => {
    if (max) {
      return `a hossznak  ${length} és ${max} között kell lennie.`
    }

    return `a hossz kell legyen ${length}.`
  },
  max: (field, [length]) => `a mező nem tartalmazhat ${length} -nál több karaktert.`,
  max_value: (field, [max]) => `a mező ${max} vagy kevesebb.`,
  mimes: () => `a mezőnek valós fáltípust kell tartalmaznia.`,
  min: (field, [length]) => `a mező minimum ${length} karakteres.`,
  min_value: (field, [min]) => `a mező ${min} vagy több.`,
  not_in: () => `a mezőnek valós értéket kell tartalmaznia.`,
  numeric: () => `a mező csak karaktereket tartalmazhat`,
  regex: () => `hibás mező formátum`,
  required: () => `kötelező mező`,
  size: (field, [size]) => `a méretnek kisebbnek kell lennie, mint ${formatFileSize(size)}.`,
  url: () => `a mező nem valós URL-t tartalmaz.`,
  fullName: () => `érték nem érvényes (Név, Keresztnév legfeljebb 120 karaktereket)`,
  emailInput: () => 'a mezőnek valós e-mail címet kell tartalmaznia.',
  fullNamePerCountry: () => 'érték nem érvényes (Név, Keresztnév legfeljebb 18 karaktereket)',
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  orderNumberPerCountry: () => `is too long`,
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'hu',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/hu.js